module.exports = __webpack_public_path__ + "img/uv_1.91990cad.png";